var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClipIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 12,
    viewBox: "0 0 20 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0156 0.984375C16.3906 0.984375 17.5625 1.48438 18.5312 2.48438C19.5 3.45312 19.9844 4.625 19.9844 6C19.9844 7.375 19.5 8.5625 18.5312 9.5625C17.5625 10.5312 16.3906 11.0156 15.0156 11.0156H10.9844V9.09375H15.0156C15.8594 9.09375 16.5781 8.79688 17.1719 8.20312C17.7969 7.57812 18.1094 6.84375 18.1094 6C18.1094 5.15625 17.7969 4.4375 17.1719 3.84375C16.5781 3.21875 15.8594 2.90625 15.0156 2.90625H10.9844V0.984375H15.0156ZM6.01562 6.98438V5.01562H13.9844V6.98438H6.01562ZM2.78125 3.84375C2.1875 4.4375 1.89062 5.15625 1.89062 6C1.89062 6.84375 2.1875 7.57812 2.78125 8.20312C3.40625 8.79688 4.14062 9.09375 4.98438 9.09375H9.01562V11.0156H4.98438C3.60938 11.0156 2.4375 10.5312 1.46875 9.5625C0.5 8.5625 0.015625 7.375 0.015625 6C0.015625 4.625 0.5 3.45312 1.46875 2.48438C2.4375 1.48438 3.60938 0.984375 4.98438 0.984375H9.01562V2.90625H4.98438C4.14062 2.90625 3.40625 3.21875 2.78125 3.84375Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipIcon);
export default __webpack_public_path__ + "static/media/clip-icon.27450abe05161bde8bacdda98014f37e.svg";
export { ForwardRef as ReactComponent };